/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import linkSite from "../linkSite/linkSite.vue";


export default {
    name: "labMaster",
    components: {
    VPagination,
    linkSite,
    customModal
  },
    data() {
        return {
            showLoading: true,
            labList: [],
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: store.getters.getStudyIs,
            labName: "",
            labType: "",
            selectedLabCode: "",
            selectedStudyId: store.getters.getStudyIs,
            showLinkSiteModal: false,
            labcode: "",
            activeSortColumn: "",
            token: "",
            SortOrder:0,
            SortProperty:"",
            pageNumber: 1,
            currentPageNumber: 1,
            currentPage: 1,
            totalItems: 0,
            totalPage: 0,
        };
    },
    async mounted() {
        this.token = store.getters.getIdToken;
        await this.getLabMaster();        
        window.addEventListener("studyIdChanged", async () => {
              this.studyId = store.getters.getStudyIs
              await this.getLabMaster();                           
            });
        this.studyId = store.getters.getStudyIs
    },
    methods: {
        async getLabMaster() {
            console.log("study id in lab master", this.studyId);
            this.showLoading = true;
            try {
            const response = await axios.get(
                `${this.baseurl}/management/labmaster/listlab?StudyId=${this.studyId}&pageindex=${this.currentPage}&pagesize=10&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
                {
                headers: {
                    Authorization: "Bearer " + this.token,
                    "Content-Type": "application/json",
                },
                }
            );
            console.log("labs are", response.data);
            this.labList = response.data && response.data.results ? response.data.results : [];
            this.totalItems = Math.ceil(response.data.totalCount / 10);
            } catch (err) {
            console.log("error..", err);
            } finally {
            this.showLoading = false;
            }
        },
        async SearchButtonClicked() {
        this.pageNumber=1;
        this.currentPageNumber=1;
        this.searchData()
        },
        async editLab(id) {
          this.$router.push(`/editLabs/${id}`);
    },
     async createlab(id) {
      this.$router.push(`/editLabs/${id}`);
    },
    async assignTest(id) {
      this.$router.push(`/assignTest/${id}`);
    },
    async linkSiteModal(labCode) {
      this.selectedLabCode = labCode;
      this.showLinkSiteModal = true;
    },
        async searchData() {
            this.showLoading = true;
            try {
            const response = await axios.get(
                `${this.baseurl}/management/labmaster/listlab?StudyId=${store.getters.getStudyIs}&LabCode=${this.labcode}&LabName=${encodeURIComponent(this.labName)}&LabType=${this.labType}&StudyId=${this.studyId}&pageindex=${this.pageNumber}&pagesize=10`,
                {
                headers: {
                    Authorization: "Bearer " + this.token,
                    "Content-Type": "application/json",
                },
                }
            );
            console.log(response);
            if (response.data) {
                this.totalItems = Math.ceil(response.data.totalCount / 10);
                this.labList = response.data.results;
            } else {
                console.log("no labs found");
            }
            } catch (error) {
            console.log(error);
            this.enableNext = false;
            this.enablePrevious = false;
            } finally {
            this.showLoading = false;
            }
        },
     async SortSelected(property) {
      // Toggle sorting direction if same column clicked again
      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0; // Default ascending
      }

      this.activeSortColumn = property;
      console.log(`Sorting by ${property}, order: ${this.SortOrder}`);
      await this.getLabMaster();
    },
        async deleteLabs(id) {
            if (confirm(this.$t('navigations.are you sure you want to delete this lab?'))) {
            await axios
                .delete(
                `${this.baseurl}/management/labmaster/deletelab?id=${id}`,
                {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                }
                )
                .then((response) => {
                if (response.data) {
                    this.labList = response.data.results;
                }
                })
                .catch((err) => {
                console.log(err);
                alert(err.response?.data?.detail || "Delete failed");
                });
            alert(this.$t("navigations.lab deleted successfully"));
            await this.getLabMaster();
           
            }
        },
          loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.getLabMaster();
    },
        
    },
};
